module.exports = __webpack_public_path__ + "static/media/26.c72c457c.jpg";